import { useQuery } from '@tanstack/react-query'
import { useContext } from 'react'
import AppContext from '@/context/appContext'
import { dataCollectionStatementService } from '@/services/farmMapping/datacollectionStatement'
import { queryKeys } from './queryKeys'

// year arrives as the route param string from DataCollectionForm.
export const useDataCollectionStatement = (year: string | number | undefined) => {
  const { currentFarm, userRoleSelected } = useContext(AppContext)
  const farmId: string | undefined = currentFarm?.id
  const userRole: string | undefined = userRoleSelected

  return useQuery({
    queryKey: queryKeys.dataCollectionStatement(farmId, year, userRole),
    queryFn: ({ signal }) =>
      dataCollectionStatementService.getByFarmYear(farmId, year, userRole, signal),
    enabled: !!farmId && !!year && !!userRole,
  })
}
